import axios from '@/api/provider';

const login = async (payload) => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refreshToken');
  return axios
    .post('auth/login', payload)
    .then((data) => ({
      accessToken: data?.access_token,
      refreshToken: data?.refresh_token,
      tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
    }));
};

const register = async ({ username, email, password, signup_code }) =>
  axios
    .post('auth/signup', { username, email, password, signup_code })
    .then((data) => ({
      accessToken: data?.access_token,
      refreshToken: data?.refresh_token,
      tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
    }));

const refresh = async () => {
  const refreshToken = localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken');
  const instance = axios.getAxiosInstance();
  return instance
    .post('auth/refresh', null, {
      headers: {
        Authorization: refreshToken ? `Bearer ${refreshToken}` : undefined,
      },
    })
    .then((resp) => resp.data)
    .then((data) => ({
      accessToken: data?.access_token,
      refreshToken: data?.refresh_token,
      tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
    }));
};

const me = async () => axios.get('auth/me');
const logout = async () => axios.post('auth/logout');
const forgetPassword = async (email) => axios.post('auth/forgot-password', { email });
const changePassword = async (email, oldPassword, newPassword) => axios.post('auth/manage/info', { newEmail: email, oldPassword, newPassword });
const resetPassword = async (token, newPassword) => axios.post('auth/reset-password', { token, new_password: newPassword });

const requestLoginCode = async (email) => axios.post('auth/request-login-code', { email });

const loginWithCode = async (email, code) => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('refreshToken');
  return axios
    .post('auth/login-with-code', { email, code })
    .then((data) => ({
      accessToken: data?.access_token,
      refreshToken: data?.refresh_token,
      tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
      loginMethod: data?.login_method,
      resetToken: data?.reset_token,
    }));
};

const impersonate = async (userId) =>
  axios.post('auth/impersonate', { user_id: userId }).then((data) => ({
    accessToken: data?.access_token,
    refreshToken: data?.refresh_token,
    tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
  }));

const stopImpersonate = async () =>
  axios.post('auth/stop-impersonate').then((data) => ({
    accessToken: data?.access_token,
    refreshToken: data?.refresh_token,
    tokenType: data?.token_type === 'bearer' ? 'Bearer' : data?.token_type,
  }));

const getImpersonationStatus = async () =>
  axios.get('auth/impersonation-status').then((data) => ({
    isImpersonating: data?.is_impersonating || false,
    impersonatorId: data?.impersonator_id,
    impersonatorUsername: data?.impersonator_username,
    impersonatedUsername: data?.impersonated_username,
  }));

const adminResetPassword = async (userId) =>
  axios.post('auth/admin/reset-password', { user_id: userId }).then((data) => ({
    status: data?.status,
    userId: data?.user_id,
    username: data?.username,
    email: data?.email,
  }));

export default {
  register,
  login,
  requestLoginCode,
  loginWithCode,
  refresh,
  me,
  logout,
  forgetPassword,
  changePassword,
  resetPassword,
  impersonate,
  stopImpersonate,
  getImpersonationStatus,
  adminResetPassword,
};
